{
  "form-listing": {
    "title": "Formularprojekte",
    "sort": "Sortieren",
    "sort-by": "Sortieren nach",
    "order": "Befehl",
    "newest-first": "Das neuste zuerst",
    "descending": "Absteigend",
    "oldest-first": "Die ältesten zu erst",
    "ascending": "aufsteigend",
    "tags": "Stichworte",
    "filter": "Filter:",
    "filter-name": "Name",
    "filter-createdAt": "Hergestellt in",
    "filter-updatedAt": "Aktualisiert am",
    "new-form": "Neues Formularprojekt",
    "new-form-subtitle": "Design und Prototyp",
    "import-form": "Vorhandenes Projekt importieren",
    "import-form-subtitle": "Importieren Sie eine „.xfe“-Datei",
    "edited": "Vor {{date}} bearbeitet"
  },
  "hub": {
    "navbar-logout": "Ausloggen",
    "navItems": {
      "forms": "Formen",
      "logs": "Protokolle"
    }
  },
  "session-logs": {
    "title": "Protokolle",
    "filter": "Projekte filtern",
    "no-logs": "Keine Protokolle verfügbar",
    "more": "Mehr",
    "item": {
      "submitted": "Vor {{date}} eingereicht",
      "session-info": "Sitzungsdaten",
      "export": "Dieses Ereignissprotokoll exportieren"
    },
    "group": {
      "export": "Alle Ereignissprotokolle dieser exportieren"
    }
  },
  "app-settings": {
    "title": "Builder Einstellungen",
    "locale": "Sprache",
    "hotkeys": "Hotkeys"
  },
  "import-form": {
    "corrupted-error": "Die Datei konnte nicht importiert werden und ist möglicherweise beschädigt.",
    "version-error": "Die Datei wurde in einer älteren Version von Form Engine erstellt.",
    "importing": "Importiere…",
    "success": "Import erfolgreich"
  }
}